// SF New Deal Official Brand Colors
// Based on brand-color-usage-guide.pdf

export const BRAND_COLORS = {
  // PRIMARY COLORS (60% usage)
  // Use for main brand elements and primary backgrounds
  midnight: '#29385D',      // RGB: 41, 56, 93 - Navy blue
  dune: '#E6E5E1',         // RGB: 230, 229, 225 - Off-white/cream

  // SECONDARY COLORS (30% usage)
  // Use for interactive elements, accents, and supporting visuals
  turquoise: '#2B75A1',    // RGB: 43, 117, 161 - Deep teal
  teal: '#49D2D0',         // RGB: 73, 210, 208 - Bright teal
  fog: '#A1E5E4',          // RGB: 161, 229, 228 - Light teal

  // ACCENT COLORS (10% usage)
  // Use sparingly for CTAs, highlights, and important UI elements
  goji: '#F45634',         // RGB: 244, 86, 52 - Coral/orange-red
  poppy: '#FF967B',        // RGB: 255, 150, 123 - Light coral
  lemon: '#FFD12E',        // RGB: 255, 209, 46 - Yellow

  // NEUTRAL
  pebble: '#3F3F3F',       // RGB: 63, 63, 63 - Dark gray
};

// Color usage recommendations based on brand guide
export const COLOR_USAGE = {
  // Headers and primary branding
  primaryHeader: BRAND_COLORS.midnight,
  primaryBrand: BRAND_COLORS.teal,

  // Backgrounds
  pageBackground: BRAND_COLORS.dune,
  cardBackground: '#FFFFFF',

  // Interactive elements (buttons, links)
  primaryButton: BRAND_COLORS.teal,
  secondaryButton: BRAND_COLORS.turquoise,
  accentButton: BRAND_COLORS.goji,

  // Status indicators
  success: BRAND_COLORS.teal,
  warning: BRAND_COLORS.lemon,
  error: BRAND_COLORS.goji,
  info: BRAND_COLORS.turquoise,

  // Text
  primaryText: BRAND_COLORS.pebble,
  secondaryText: '#6B7280',
  lightText: '#FFFFFF',

  // Accents and highlights
  highlight: BRAND_COLORS.lemon,
  accentPrimary: BRAND_COLORS.goji,
  accentSecondary: BRAND_COLORS.poppy,
  subtle: BRAND_COLORS.fog,
};

// Gradient combinations from brand guide
export const GRADIENTS = {
  brandBar: `linear-gradient(90deg, ${BRAND_COLORS.teal} 0%, ${BRAND_COLORS.turquoise} 50%, ${BRAND_COLORS.fog} 100%)`,
  warmAccent: `linear-gradient(90deg, ${BRAND_COLORS.goji} 0%, ${BRAND_COLORS.poppy} 100%)`,
  coolAccent: `linear-gradient(90deg, ${BRAND_COLORS.turquoise} 0%, ${BRAND_COLORS.teal} 100%)`,
};

export default BRAND_COLORS;
